import { createBrowserRouter, RouterProvider } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import DefaultDashboard from "./Dashboard/Default";
import BehaviourDashboard from "./Dashboard/Behaviour";
import Overview from "./Sis/Overview/StudentsOverview";
import Admission from "./Sis/Admission";
import ErrorPage from "./ErrorPage/ErrorPage";
import TeachersAdmission from "./Tis/TeachersAdmission";
import SchoolDashboard from "./School-Registration/School/Dashboard";
import UserDetail from "./School-Registration/School/Schools";
import AddSchool from "./School-Registration/School/AddSchool";
import AddUser from "./School-Registration/School/AddUser";
import LoginPage from "./Login/login";
import Logout from "./Login/logout";
import TeacherOverview from "./Tis/Overview/TeachersOverview";
import StudentProfile from "./Sis/Overview/StudentProfile/studentProfile";
import Attendance from "./Sis/Attendance";
import DefaultTable from "./Dashboard/studentBehaviours";
import EditSchool from "./School-Registration/School/EditSchool";
import DMS from "./Transport/Dms/DMS";
import BehaviourRightSec from "./Dashboard/Behaviour/Base";
import StudentPerformance from "./Dashboard/StudentBehaviour/studentPerformance";
import SubjectAnalytics from "./Dashboard/StudentBehaviour/subjectPerformance";
import MainHeader from "./commonComp/MainHeader";
import Sidebar from "./commonComp/SideBar";


const DashboardLayout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                if (!isSidebarOpen) {
                    setIsSidebarOpen(true);
                }
            } else {
                if (isSidebarOpen) {
                    setIsSidebarOpen(false);
                }
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isSidebarOpen]);

    return (
        <div className="flex h-screen w-screen">
           
           <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

            <div className="flex flex-col overflow-hidden w-screen">
                <MainHeader
                isSidebarOpen={isSidebarOpen}
                setIsSidebarOpen={setIsSidebarOpen}
            />

                {isSidebarOpen && (
                    <div
                        className="fixed inset-0 bg-black/40 z-20 md:hidden"
                        onClick={() => setIsSidebarOpen(false)}
                    />
                )}

                <main className="flex-1 overflow-y-auto scrollbar-hide p-2 relative z-10">
                    {children}
                </main>
            </div>
        </div>
    );
};

const CreateElements = ({ Comp }) => {
    return (
        <DashboardLayout>
            {Comp}
        </DashboardLayout>
    );
};

const routes = createBrowserRouter([
    { path: "/", element: <CreateElements Comp={<DefaultDashboard />} /> },
    { path: "/login", element: <LoginPage /> },
    { path: "/logout", element: <Logout /> },
    { path: "/dashboard/:date?", element: <CreateElements Comp={<BehaviourDashboard />} /> },
    { path: "/behaviour/:class?", element: <CreateElements Comp={<BehaviourDashboard />} /> },
    { path: "/StudentPerformance/:id/:name", element: <CreateElements Comp={<StudentPerformance />} /> },
    { path: "/SubjectPerformance/:id/:name/:subject", element: <CreateElements Comp={<SubjectAnalytics />} /> },
    { path: "/students/overview", element: <CreateElements Comp={<Overview />} /> },
    { path: "/students/profile/:id", element: <CreateElements Comp={<StudentProfile />} /> },
    { path: "/students/admission", element: <CreateElements Comp={<Admission />} /> },
    { path: "/students/edit/:id", element: <CreateElements Comp={<Admission />} /> },
    { path: "/students/Attendance", element: <CreateElements Comp={<Attendance />} /> },
    { path: "/teachers/teacheradmission", element: <CreateElements Comp={<TeachersAdmission />} /> },
    { path: "/error", element: <CreateElements Comp={<ErrorPage />} /> },
    { path: '/add-school', element: <CreateElements Comp={<AddSchool />} /> },
    { path: '/add-user/:id', element: <CreateElements Comp={<AddUser />} /> },
    { path: '/school', element: <CreateElements Comp={<SchoolDashboard />} /> },
    { path: '/schooldetails/:id', element: <CreateElements Comp={<UserDetail />} /> },
    { path: '/edit-school/:id', element: <CreateElements Comp={<EditSchool />} /> },
    { path: "*", element: <ErrorPage /> },
    { path: '/teachers/overview', element: <CreateElements Comp={<TeacherOverview />} /> },
    { path: "/student-behaviour", element: <CreateElements Comp={<DefaultTable />} /> },
    { path: "/transport/dms", element: <CreateElements Comp={<DMS />} /> },
    { path: "/behaviour-dashboard", element: <CreateElements Comp={<BehaviourRightSec />} /> },
]);

function App() {
    return (
        <div className="flex">
            <RouterProvider router={routes} />
        </div>
    );
}

export default App;